/**
 * Black Box — per-page config presets.
 *
 * The universal events + DOM snapshot work on any page with no config. The
 * PER-PAGE bits — which containers are "steps", which inputs are which field,
 * which divs are error slots, and what counts as a conversion — are CSS
 * selectors that differ per page. Presets are legacy/bundled configs; new sites
 * are configured from the dashboard (Flow setup) instead.
 *
 * A page selects its preset (priority order, highest first):
 *   1. <script src=".../blackbox.js" data-bb-preset="ro-nord">
 *   2. ?bbpreset=ro-nord   (testing)
 *   3. matchPreset(location) — auto-match by URL
 * …and can still override any field via BlackBox.init({ steps:{…} }).
 */
export const PRESETS = {
  // Romania · NordVPN (the demo checkout — demo-page/index.html)
  'ro-nord': {
    steps: { phone: '#step1', otp: '#step2', coming_soon: '#coming-soon-step' },
    fields: { phone: '#phone-input', otp: '#pin-input' },
    errors: { phone: '#error-message', otp: '#pin-error' },
    conversion: { successSelector: null, apiSuccessUrl: '/dcb/confirm' },
  },

  // Prefer the dashboard (Flow setup) for new sites; add a bundled preset only
  // when a page must work with zero server round-trip.
};

/** Best-effort auto-match a preset key from the current URL (host/path).
 *  Market-scoped: a preset only matches its own market's URL (product AND
 *  market must both appear), so ro-nord never captures e.g. /nord-vpn/bg. */
export function matchPreset(loc) {
  try {
    const hay = ((loc.host || '') + (loc.pathname || '')).toLowerCase();
    if (/nord/.test(hay) && /(^|[/.-])ro([/.-]|$)/.test(hay)) return 'ro-nord';
  } catch (_) {}
  return null;
}
